import { USER_TYPE } from 'app/config/users';

export const checkCooperative = padVisit => {
  const { responsibleId, responsibleType } = padVisit;
  return responsibleType === USER_TYPE.COOPERATIVE || !!responsibleId;
};
